import { createStore as reduxCreateStore } from "redux";

const reducer = (state, action) => {
  if (action.type === `ADD_ANSWER`) {
    const alreadyAnswered = state.questionHistory.some(question => {
      return question.slug === action.answer.slug;
    });
    if (alreadyAnswered) {
      return state;
    }
    return {
      ...state,
      questionHistory: [...state.questionHistory, action.answer]
    };
  }
  if (action.type === `POP_ANSWERS`) {
    return {
      ...state,
      questionHistory: state.questionHistory.slice(0, -1 * action.n)
    };
  }
  if (action.type === `RESET_ANSWERS`) {
    return {
      ...state,
      questionHistory: []
    };
  }
  return state;
};

const initialState = { questionHistory: [] };

const createStore = () => reduxCreateStore(reducer, initialState);
export default createStore;
